import GiftBoxApi from '@apis/gift/GiftBoxApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
    GetGiftBoxParams,
    GetReceivedGiftBoxParams,
    GetSentGiftBoxParams,
    GiftBoxType,
} from '@models/gift';

const giftBoxQueries = createQueryKeys('giftBox', {
    list: (giftBoxType: GiftBoxType, sorter: string) => ({
        queryKey: [giftBoxType, sorter],
        queryFn: () => GiftBoxApi.getGiftBoxes(giftBoxType, sorter),
    }),
    received: (params: Omit<GetReceivedGiftBoxParams, 'page'>) => ({
        queryKey: ['received', params],
    }),
    sent: (params: Omit<GetSentGiftBoxParams, 'page'>) => ({
        queryKey: ['sent', params],
    }),
    detail: (giftBoxId: string, params: GetGiftBoxParams) => ({
        queryKey: [giftBoxId, params],
        queryFn: () => GiftBoxApi.getGiftBox(giftBoxId, params),
    }),
    usage: (giftCouponId: string) => ({
        queryKey: ['usage', giftCouponId],
        queryFn: () => GiftBoxApi.getUsage(giftCouponId),
    }),
});

export default giftBoxQueries;
